import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LabelLine } from 'components/InputV2/components';
import { Button, Grid, InputLabel, Select, MenuItem, CircularProgress, Box } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { validator } from 'myValidation';
import { useParams, useLocation } from 'react-router-dom';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import axios from 'axios';
import {
  PageContainer,
  TableComponents,
  ButtonLoading,
  SimpleDialog,
  InputV2,
  TableItemActionsNew,
  Icons,
  FilterPod
} from 'components';
import InitFilters from './components/InitFiltering';
import { columns, generateData } from './components/Columns';
import Services from '../Services';
import { useStyles } from './style';
import { usePageDispatcher, useQuery } from 'hooks';
import createToast from 'components/Toast/Toast';
import useCustomHook from './hooks';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import { legalUser, naturalUser, customFilter, inputTypeUserName } from './components/InitFiltering';
import { FILTER_TYPES } from 'components/FilterPod';
const defaultIdentityType = 'username';
export default function ACLUserList() {
  const paramUrl = useParams();
  const query = useQuery();
  let tableRef = useRef();
  //--HOOKS--//
  const classes = useStyles();
  const setPageDispatcher = usePageDispatcher();
  const {
    loading,
    setLoading,
    setFilterParams,
    size,
    setSize,
    identity,
    setIdentity,
    loadingBtn,
    setLoadingBtn,
    selectedRow,
    setSelectedRow,
    isOpendialog,
    setIsOpenDialog,
    removeDialog,
    setRemoveDialog,
    identityType,
    setIdentityType,
    selectRowForPayer,
    setSelectRowForPayer,
    selectedRowPayerFinger,
    setSelectedRowPayerFinger,
    isLoadingListPayer,
    setIsLoadingListPayer,
    isLoadingNewPayer,
    setIsLoadingNewPayer,
    userType,
    setUserType,
    birthDate,
    setBirthDate,
    page,
    setPage,
    userDetail, setUserDetail,
    pageTitle, setPageTitle,
    superAdminObject, setSuperAdminObject,
    isLoadingSupreAdmin, setIsLoadingSupreAdmin,
    filters, setFilters,
    openFilterDialog, setOpenFilterDialog,
    isLoadingFilter, setIsLoadingFilter,
    copyOriginalFilter, setCopyOriginalFilter,
    copyTempFilter, setCopyTempFilter,
    setCopyOpenDgFilter,
    isLoadingCheckSuperAdmin, setIsLoadingCheckSuperAdmin
  } = useCustomHook();
  const handleCloseFilterDialog = () => {
    setOpenFilterDialog(false);
    setFilters([...JSON.parse(copyOriginalFilter)])
    setCopyOriginalFilter(null);
    setCopyTempFilter(null)
  }

  const navigate = useNavigate();
  const location = useLocation();
  const methods = useForm();
  const { handleSubmit, /* reset, */ control, register } = methods;
  let identityTypeOptions = [
    { value: 'username', label: 'نام کاربری' },
    { value: 'email', label: 'پست الکترونیک' },
    { value: 'phone_number', label: 'تلفن همراه' },
    { value: 'id', label: 'شناسه' },
    { value: 'nationalcode', label: 'کد ملی' },
  ];


  /**
 * چک میکند کاربر از نوع سوپر ادمین هست یا خیر
 */
  const onCheckAdmin = (isclick = false) => {
    if (isclick) {
      if (superAdminObject.getData === true) return;
      setSuperAdminObject({ ...superAdminObject, getData: true })
      setIsLoadingSupreAdmin(true)
      Services.checkAdmin().then(res => {
        setIsLoadingSupreAdmin(false);
        setSuperAdminObject({ getData: true, isAdmin: res?.result?.isAdmin || false })
      }).catch(err => {
        setIsLoadingSupreAdmin(false);
      })
    } else {
      Services.checkAdmin().then(res => {
        setFilters(InitFilters(res?.result?.isAdmin))
        setSuperAdminObject({ isAdmin: res?.result?.isAdmin || false, getData: true })
        setIsLoadingCheckSuperAdmin(false)

      }).catch(err => {
        setIsLoadingCheckSuperAdmin(false)
      })
    }
  }

  useEffect(() => {
    if (query.get('title') !== null) {
      setPageTitle(pageTitle + query.get('title'))
    }
    onCheckAdmin();
  }, [])

  useEffect(() => {
    if (openFilterDialog === true) {
      setCopyOriginalFilter(JSON.stringify(filters))
    } else {
      setCopyOriginalFilter(null);
      setCopyTempFilter(null)
    }

  }, [openFilterDialog])

  const actionsList =
    getDynamicObjectAction([
      'addACLUsersBtn',
      'deleteACLBtn'

    ])


  //--API REQUESTS--//
  const getList = async (query) => {
    try {
      let uTypes = {
        "1": true,
        "2": false
      };
      const filter = toFilterVOS([...filters]);
      const queries = filterVOStoQueryStr(filter);
      setLoading(true);
      let params = {
        isLegal: queries['userType'] ? (queries['userType'] === '1' ? true : false) : null,
        memberType: queries['userTypeList'] ? queries['userTypeList'] : null,
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query?.pageSize || size,
        member: queries['inputType'] ||
          queries['username'] ||
          queries['email'] ||
          queries['id'] ||
          queries['phone_number'] ||
          queries['nationalcode'] || null
      };

      const data = {
        filterVOS: [],
        parentParams: [],
        orderByElementVOS: [],
      };

      setFilterParams({ data, params });

      const res = await Services.getMemberListAcl(paramUrl?.path, params);
      let list = [];

      list = generateData(res?.result, {
        page: query ? query?.pageNumber : page,
        pageSize: query?.pageSize || size,
      });
      setLoading(false);

      let d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count || res?.result?.count || res?.result?.right,
      };
      return d; //passed to MaterialTable
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  const setDefaultNewPayer = () => {
    setIsOpenDialog(false);
    setTimeout(() => {
      setIdentity('');
      methods.setValue('identity', '');
      setIdentityType(defaultIdentityType);
      setBirthDate(null);
      setUserType(true);
    }, 500);
  };
  /**
   * ایجاد پرداخت کننده جدید
   */
  const onCreateNewPayer = async () => {
    const values = methods.getValues();
    if (!identity || !identity.trim()) {
      createToast('خطا', 'لطفا تمامی فیلدها را بدرستی وارد نمایید.', 'danger');

      return;
    }
    //validator.isEmail;
    if (identityType == 'email') {
      if (!validator.isEmail(identity)) {
        createToast('خطا', 'لطفا ایمیل را بدرستی وارد نمایید.', 'danger');
        return;
      }
    }
    if (identityType == 'phone_number') {
      if (!validator.isNumeric(identity)) {
        createToast('خطا', 'لطفا شماره موبایل را بدرستی وارد نمایید.', 'danger');
        return;
      }
    }
    let data = {
      isLegal: userType,
      member: identity,
      memberType: identityType,
    }

    setIsLoadingNewPayer(true);
    Services.addAclMemberToGroup(data, paramUrl.path)
      .then((res) => {
        setIsLoadingNewPayer(false);
        setDefaultNewPayer();
        createToast('موفق', 'اطلاعات باموفقیت ثبت شد.', 'success');
        setIsOpenDialog(false);
        setPage(0);
        setSize(10);
        setTimeout(() => {
          tableRef?.current?.onChangeTable();
        }, 100);
      })
      .catch((error) => {
        setIsLoadingNewPayer(false);
        const statusError = error?.response?.data?.status;
      });
  };
  const ChangeStateActionBtn = () => {
    return (
      <>
        <ButtonLoading
          type="submit"
          variant="contained"
          color="primary"
          loading={loadingBtn}
          name="بله"
          onClick={removeMember}
        />

        <Button variant="contained" onClick={handleCloseDialog}>
          انصراف
        </Button>
      </>
    );
  };
  const removeMember = () => {
    setLoadingBtn(true);
    Services.deleteAclUser(paramUrl?.path, selectedRow?.id, {
      isLegal: selectedRow?.isBranch || false,
    })
      .then((res) => {
        createToast('موفق', 'عملیات با موفقیت انجام شد', 'success');
        setTimeout(() => {
          tableRef?.current?.onChangeTable();
        }, 100);
        handleCloseDialog();
        setLoadingBtn(false);
      })
      .catch((error) => {
        setLoadingBtn(false);
      });
  };
  const handleCloseDialog = () => {
    setRemoveDialog({ title: '', content: '', open: false });
  };




  const clearAllFilters = (tempFilters, key) => {
    if (key === 'clear') {
      setFilters(InitFilters(superAdminObject.isAdmin))
      setPage(0)
      setSize(10)
      setTimeout(() => {
        tableRef?.current?.onChangeTable(true);
      }, 100)
    }
  }

  const onFiltersChange = (newFilters) => {
    setCopyOriginalFilter(null);
    setCopyTempFilter(null)
    if (!newFilters[0]?.value) {
      setFilters(InitFilters(superAdminObject.isAdmin))
      setCopyOpenDgFilter(null);
    } else {
      setFilters([...newFilters])
    }

    //================چک میکند اگر فیلتر سومی رو چیزی وارد نکرده باشد به کاربر خطا نمایش میدهد و سرویس کال نمیشود
    const filter = toFilterVOS([...newFilters]);
    if (filter.length === 2) {
      createToast('خطا', `لطفا فیلد ${newFilters[2]?.title} را وارد نمایید.`, 'danger');
      return
    }
    //=======================
    setPage(0)
    setSize(10)
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100)
  };


  const setValueToFilter = (obj, isShowLoading = false) => {
    if (Array.from(obj)[2]?.keyName === 'inputType' || Array.from(obj)[2]?.keyName === 'username') {
      setFilters(prev => [obj[0], obj[1], customFilter.id])
    }
    setTimeout(() => {
      setFilters(prev => obj)
    }, 1);
    setCopyTempFilter(JSON.stringify(obj))

  }

  const onChangeFilterItem = async (tempFilters) => {
    let inputType = {
      title: 'نام کاربری',
      label: 'نام کاربری',
      keyName: 'inputType',
      id: 4,
      value: '',
      filterType: FILTER_TYPES.text,
      filterProps: { dir: 'ltr', englishNumber: true },
      disableDelete: true,
    };

    let typeSeletct = {
      '1': legalUser,
      '2': naturalUser
    }

    if (!tempFilters || tempFilters.length === 0 || !openFilterDialog) { // خالی برگرده
      return
    }
    if (JSON.parse(copyOriginalFilter)[0]?.value !== tempFilters[0]?.value) { // اگر حقیقی یا حقوقی تغییر کرده باشد

      if (!copyTempFilter || JSON.parse(copyTempFilter)[0]?.value !== tempFilters[0]?.value) { // کپی خالی باشه یا کپی حقیقی و حقوقی تغییر کرده باشه
        let obj = [tempFilters[0], ...typeSeletct[tempFilters[0]?.value], JSON.parse(JSON.stringify(inputType))];
        setValueToFilter(obj, true)
      } else if (JSON.parse(copyTempFilter)[0]?.value === tempFilters[0]?.value &&
        JSON.parse(copyTempFilter)[1]?.value !== tempFilters[1]?.value) { // 
        let obj = [tempFilters[0], tempFilters[1], customFilter[tempFilters[1]?.value]];
        setValueToFilter(obj, true)
      }
    } else { // اگه حقیقی و حقوقی بدون تغییر باشه
      if (!copyTempFilter &&
        (JSON.parse(copyOriginalFilter)[0]?.value !== tempFilters[0]?.value ||
          JSON.parse(copyOriginalFilter)[1]?.value !== tempFilters[1]?.value)) { // دیالوگ فیلتر بار دوم باز شده و تغییرات روی فیلتر میخواد انجام بده -کمبوباکس اول و دوم باید تغییر کرده باشد 
        let obj = [tempFilters[0], tempFilters[1], customFilter[tempFilters[1]?.value]];
        setValueToFilter(obj)
        return;
      }
      if (filters[0]?.value !== tempFilters[0]?.value) { // فیلتر فعلی رو با فیلتر برگشتی مقایسه میکنه
        let obj = [tempFilters[0], ...typeSeletct[tempFilters[0]?.value], JSON.parse(JSON.stringify(inputType))];
        setValueToFilter(obj)
        return;
      }
      if (copyTempFilter && JSON.parse(copyTempFilter)[0]?.value !== tempFilters[0]?.value) { // مقدار کپی اولی و مقدار برگشت تغییر کرده باشه
        let obj = [tempFilters[0], tempFilters[1], customFilter[tempFilters[1]?.value]];
        setValueToFilter(obj)
      } else if (copyTempFilter && JSON.parse(copyTempFilter)[0]?.value === tempFilters[0]?.value &&
        JSON.parse(copyTempFilter)[1]?.value !== tempFilters[1]?.value) { // مقدا اولی و کپی برابره ولی مقدار کمبوباکس دومی تغییر کرده
        let obj = [tempFilters[0], tempFilters[1], customFilter[tempFilters[1]?.value]];
        setValueToFilter(obj)
      }
    }
  }


  const hint = 'در این بخش  میتوانید لیست کاربران  و دسترسی ها را مشاهده و ویرایش کنید.';

  return (
    <>
      <PageContainer
        title={' لیست کاربران گروه ' + query.get('title') || ''}
        description={hint}
        breadcrumbs={constBreadCrumbsTitle.ACL_ADD_USER}
        className={classes.root}
        loading={isLoadingCheckSuperAdmin}
        meta={
          <Button
            color="primary"
            variant="outlined"
            endIcon={<Icons icon="CaretLeft" color="#2b3990" size="23" />}
            onClick={() => {
              setPageDispatcher({
                page: location?.state?.page,
                action: 'POP',
                pageSize: location?.state?.pageSize,
              });
              navigate('/ACL');
            }}
          >
            بازگشت به مدیریت دسترسی ها
          </Button>
        }
      >
        <Grid
          item
          className={classes.actionButton}
        >

          <Grid item xs={12} className={classes.filterbtn}>
            <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
              <FilterButton
                setOpenFilterDialog={setOpenFilterDialog}
                filters={filters}
              />
            </Box>
            <Box>
              <FilterPod
                filters={filters}
                onChange={onFiltersChange}
                onChangeFilterItem={onChangeFilterItem}
                openFilterDialog={openFilterDialog}
                setOpenFilterDialog={setOpenFilterDialog}
                handleCloseFilterDialog={handleCloseFilterDialog}
                isLoading={isLoadingFilter}
                isShowCustomRemoveBtn={true}
                clearAllFilters={clearAllFilters}
              />
            </Box>

          </Grid>

          <Grid className={classes.addUserBtn}>
            <Button

              className={classes.cardHeaderButton}
              onClick={() => {
                setIsOpenDialog(true);
                onCheckAdmin(true);
              }}
              startIcon={<Icons icon='plusCircle' color='#fff' size='18' />}
              color="primary"
              variant="contained"
            >
              افزودن کاربر
            </Button>
          </Grid>
        </Grid>

        <TableComponents
          data={getList}
          columns={columns(actionsList, setSelectedRow, setRemoveDialog)}
          isLoading={loading}
          ref={tableRef}
          onChange={(ps) => {
            setPage(ps?.pageNumber);
            setSize(ps?.pageSize);
            return getList(ps);
          }}

        />

        <SimpleDialog
          title="کاربر جدید"
          open={isOpendialog}
          maxWidth="sm"
          icon={<Icons icon='users2' color='#2B3990' size='23' />}
          onClose={() => setDefaultNewPayer()}
        >
          {isLoadingSupreAdmin && (
            <div className={classes.dgAddUserLoading}>
              <CircularProgress size={24} />
            </div>
          )}
          {!isLoadingSupreAdmin && (<FormProvider {...methods}>
            <form
              onSubmit={methods.handleSubmit(onCreateNewPayer)}
              className={classes.form}
              noValidate
              autoComplete="off"
            >
              <Grid
                item
                md={12}
                xs={12}
                style={{ height: '260px', overflowY: 'auto', padding: '0 16px' }}
              >
                <Grid item md={12} xs={12} style={{ marginBottom: '12px' }}>
                  <InputLabel
                    shrink
                    className={classes.label}
                    style={{ display: 'flex', fontSize: '17px', marginBottom: '2px' }}
                  >
                    <span style={{ color: '#ef5350', margin: '0 4px' }}>*</span>
                    <LabelLine label="نوع کاربر" style={{ fontSize: '15px !important' }} />
                  </InputLabel>
                  <Select
                    fullWidth
                    value={userType}
                    name="userType"
                    disabled={superAdminObject.isAdmin}
                    onChange={(e) => {
                      setUserType(e.target.value);
                      if (e.target.value === true) {
                        if (identityType == 'phone_number' || identityType == 'nationalcode') {
                          setTimeout(() => {

                            setIdentityType('username');
                            methods.setValue('identity', '');
                          }, 10);
                          setIdentity('');
                        }
                      }
                    }}
                    variant="outlined"
                    required={true}
                    rules={['required']}
                    errors={methods.formState.errors}
                    register={methods.register}
                    style={{ height: 38 }}
                    className="pureSelect"
                  >
                    <MenuItem value={false}>کاربر حقیقی(پادی)</MenuItem>
                    <MenuItem value={true}>کاربر حقوقی(شعب)</MenuItem>
                  </Select>
                </Grid>

                <Grid item md={12} xs={12}>
                  <InputLabel
                    shrink
                    className={classes.label}
                    style={{ display: 'flex', fontSize: '17px', marginBottom: '2px' }}
                  >
                    <span style={{ color: '#ef5350', margin: '0 4px' }}>*</span>
                    <LabelLine label="نوع اطلاعات کاربر" />
                  </InputLabel>
                  <Select
                    fullWidth
                    value={identityType}
                    name="category"
                    onChange={(e) => {
                      methods.setValue('identity', '');
                      setIdentity('');
                      setIdentityType(e.target.value);
                    }}
                    variant="outlined"
                    required={true}
                    rules={['required']}
                    errors={methods.formState.errors}
                    register={methods.register}
                    style={{ height: 38 }}
                    className="pureSelect"
                  >
                    {identityTypeOptions.map((item, index) => {

                         if ((item.value == 'id') && !userType ){
                          return null
                      }
                      return (
                        <MenuItem
                          disabled={
                            userType &&
                            (item.value == 'phone_number' || item.value == 'nationalcode')
                          }
                          value={item.value}
                        >
                          {item.label}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </Grid>

                <InputV2
                  control={control}
                  register={register}
                  errors={{}}
                  rules={['required']}
                  name="identity"
                  label={`${identityTypeOptions.find((a) => a.value == identityType).label
                    } کاربر مورد نظر`}
                  mainStyle={{ width: '100%', marginLeft: 0, marginRight: 0 }}
                  fullWidth
                  dir="ltr"
                  placeholder=""
                  defaultValue={identity}
                  onChangeValue={(v) => {
                    setIdentity(v.target.value);
                  }}
                />

              </Grid>

              <Grid direction="row" container item xs={12} justifyContent='flex-end'>
                 <Button
                  variant="contained"
                  onClick={() => setDefaultNewPayer()}
                   style={{ marginLeft: '10px' }}
                >
                  انصراف
                </Button>
                
                <ButtonLoading
                  type="submit"
                  name="ثبت"
                  variant="contained"
                  color="primary"
                  loading={isLoadingNewPayer}
                 
                />
               
              </Grid>
            </form>
          </FormProvider>)
          }


        </SimpleDialog>

        <SimpleDialog
          title={removeDialog?.title}
          content={removeDialog?.content}
          open={removeDialog?.open || false}
          actions={<ChangeStateActionBtn />}
        />
      </PageContainer>
    </>
  );
}
